module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Newsfeed.js"));
	}, "Newsfeed");
}